import {Value} from "./value";
import {UnitType} from "./unitType";

export class Centimeters extends Value {
    constructor(value: number) {
        super(value, UnitType.CM);
    }
}
